import React from 'react';
import { Helmet } from 'react-helmet-async';
import { FAQConfig } from '../../config';
import FAQDesktop from './FAQ_Desktop';
import FAQMobile from './FAQ_Mobile';

const FAQ = ({ lang, screen }) => {
  const { tags, title, items } = FAQConfig();

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question.it,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer.it,
      },
    })),
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      {screen > 1380
        ? <FAQDesktop lang={lang} tags={tags} title={title} items={items} />
        : <FAQMobile lang={lang} tags={tags} title={title} items={items} />
      }
    </>
  );
};

export default FAQ;
